import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutubeNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M17.17 6.673a1.87 1.87 0 0 0-1.315-1.344C14.675 5 10.014 5 10.014 5s-4.69 0-5.869.33A1.87 1.87 0 0 0 2.83 6.672c-.329 1.151-.329 3.62-.329 3.62s0 2.44.33 3.62a1.83 1.83 0 0 0 1.315 1.316c1.18.301 5.869.301 5.869.301s4.662 0 5.84-.301a1.83 1.83 0 0 0 1.317-1.317c.329-1.179.329-3.62.329-3.62s0-2.468-.33-3.62m-8.692 5.84V8.072l3.894 2.222z"
    />
  </svg>
);
export default SvgYoutubeNegative;
